import { render } from "./UserMyAccount.vue?vue&type=template&id=0c388996"
import script from "./UserMyAccount.vue?vue&type=script&lang=js"
export * from "./UserMyAccount.vue?vue&type=script&lang=js"

import exportComponent from "/Users/mac/Projects/webshop/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__